

export enum KalturaSessionType {
    admin=2,
	user=0
}